import "./PublishStatus.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Button } from "components/Button/Button";
import useUserData from "hooks/useUserData";
import { UserRoleIds } from "utils/userRoles";

export const PUBLISH_STATUS = {
	UNPUBLISHED: 0,
	PUBLISHED: 1,
};

const PUBLISH_STATUS_META = {
	[PUBLISH_STATUS.UNPUBLISHED]: {
		label: "Unpublished",
		icon: faTriangleExclamation,
		color: "#F68B1F",
		className: "is-unpublished",
	},
	[PUBLISH_STATUS.PUBLISHED]: {
		label: "Published",
		icon: faCheck,
		color: "#1ea324",
		className: "is-published",
	},
};

const getPublishStatusMeta = (status) =>
	PUBLISH_STATUS_META[status] ?? { label: `Unknown (${status})`, icon: null, color: "#999", className: "is-unknown" };

const PublishStatus = ({ status, handleOpenDiscardModal, handleOpenPublishModal }) => {
	const { label, icon, color, className } = getPublishStatusMeta(status);
	const { userData } = useUserData();

	return (
		<div className={`publish-status ${className}`} data-status-code={status}>
			<h1>Status</h1>
			<p className="publish-status__value">
				{icon && (
					<FontAwesomeIcon
						icon={icon}
						style={{ color, marginRight: 8 }}
						aria-hidden="true"
					/>
				)}
				<span>{label}</span>
			</p>
			<div className="publish-status-buttons">
				<Button text="Discard Current Changes" onClick={handleOpenDiscardModal} disabled={status === PUBLISH_STATUS.PUBLISHED} />
				<Button text="Publish" onClick={handleOpenPublishModal} disabled={status === PUBLISH_STATUS.PUBLISHED || userData.RoleId !== UserRoleIds.ContentPublisher} />
			</div>
		</div>
	);
};

export default PublishStatus;
